var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_2642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7713 11.1045L8.94266 13.9331C8.81895 14.057 8.67206 14.1552 8.51037 14.2222C8.34867 14.2892 8.17536 14.3237 8.00033 14.3237C7.82529 14.3237 7.65198 14.2892 7.49029 14.2222C7.32859 14.1552 7.1817 14.057 7.05799 13.9331L4.22866 11.1045C3.48281 10.3586 2.97488 9.40827 2.76912 8.37371C2.56335 7.33916 2.66899 6.26681 3.07266 5.29229C3.47634 4.31777 4.15992 3.48483 5.03698 2.89881C5.91404 2.31279 6.94517 2 7.99999 2C9.05481 2 10.0859 2.31279 10.963 2.89881C11.8401 3.48483 12.5236 4.31777 12.9273 5.29229C13.331 6.26681 13.4366 7.33916 13.2309 8.37371C13.0251 9.40827 12.5172 10.3586 11.7713 11.1045Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.3335C10 7.86393 9.78929 8.37264 9.41421 8.74771C9.03914 9.12278 8.53043 9.3335 8 9.3335C7.46957 9.3335 6.96086 9.12278 6.58579 8.74771C6.21071 8.37264 6 7.86393 6 7.3335C6 6.80306 6.21071 6.29436 6.58579 5.91928C6.96086 5.54421 7.46957 5.3335 8 5.3335C8.53043 5.3335 9.03914 5.54421 9.41421 5.91928C9.78929 6.29436 10 6.80306 10 7.3335Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_2642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF1);
export default __webpack_public_path__ + "static/media/f1.4303ace893976c71fd06e4ab19355c01.svg";
export { ForwardRef as ReactComponent };